import { DataState } from "Models/Common/DataState";
import { Reducer } from "redux";
import { ActionTypes, AuditTemplateActions } from "./AuditTemplateActionTypes";
import { AuditTemplateState, IAuditTemplateState } from "./AuditTemplateState";

export const initialState: IAuditTemplateState = new AuditTemplateState();

const reducer: Reducer<IAuditTemplateState> = (state: IAuditTemplateState = initialState, action: AuditTemplateActions) => {
    switch (action.type) {
        case ActionTypes.SUGGESTIONS_RETRIEVED:
            return { ...state, suggestions: action.data };
        case ActionTypes.AUDIT_SUGGESTION_RETRIEVED:
            return { ...state, selectedSuggestion: action.data };
        case ActionTypes.CLEAR_AUDIT_TEMPLATES:
            return { ...state, auditTemplates: [] };
        case ActionTypes.AUDIT_FILTER_UPDATED:
            return { ...state, currentFilter: action.filter, isLoading: true };
        case ActionTypes.AUDIT_PAGE_RETRIEVED:
            const auditTemplates = state.auditTemplates ? [...state.auditTemplates] : [];
            const newTemplates = action.page.items.filter(newAuditTemplate => auditTemplates.find(t => t.id === newAuditTemplate.id) === undefined);
            auditTemplates.push(...newTemplates);
            return { ...state, auditTemplates, totalAudits: action.page.totalItems, isLoading: false };
        case ActionTypes.AUDIT_TEMPLATE_STATE_CHANGED:
            return { ...state, detailAuditTemplateStates: { ...state.detailAuditTemplateStates, [action.auditTemplateId || -1]: action.newState } };
        case ActionTypes.AUDIT_TEMPLATE_RETRIEVED:
            return {
                ...state,
                detailAuditTemplates: { ...state.detailAuditTemplates, [action.auditTemplate.id!]: action.auditTemplate },
                detailAuditTemplateStates: { ...state.detailAuditTemplateStates, [action.auditTemplate.id!]: DataState.Done }
            };
        case ActionTypes.SHOW_VALIDATION_ERRORS:
            const distinctValidationErrors = Array.from(new Set(action.validationErrors));
            return { ...state, detailAuditTemplateValidationErrors: { ...state.detailAuditTemplateValidationErrors, [action.auditTemplateId || -1]: distinctValidationErrors } };
        case ActionTypes.CLEAR_VALIDATION_ERRORS:
            return { ...state, detailAuditTemplateValidationErrors: { ...state.detailAuditTemplateValidationErrors, [action.auditTemplateId || -1]: [] } };
        case ActionTypes.AUDIT_TEMPLATE_SAVED:
            return {
                ...state,
                auditTemplates: [],
                detailAuditTemplates: { ...state.detailAuditTemplates, [action.auditTemplate.id!]: action.auditTemplate },
                detailAuditTemplateStates: { ...state.detailAuditTemplates, [action.auditTemplate.id!]: DataState.Done }
            };
        case ActionTypes.AUDIT_TEMPLATE_DELETED:
            // Remove the template from the overview page
            if (state.auditTemplates) {
                const index = state.auditTemplates.findIndex(x => x.id === action.auditTemplateId);
                if (index >= 0) {
                    state.auditTemplates.splice(index, 1);
                }
            }

            // Remove the template from the template detail storage
            if (state.detailAuditTemplates && state.detailAuditTemplates[action.auditTemplateId]) {
                delete state.detailAuditTemplates[action.auditTemplateId];
            }

            return {
                ...state,
                detailAuditTemplateStates: { ...state.detailAuditTemplateStates, [action.auditTemplateId]: DataState.Deleted }
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/AuditTemplates/AuditTemplateReducer.ts